import { v } from 'convex/values'

// Before/after journeys (journeys.ts): a goal's starting point, milestone
// check-ins and finish, shared as a card and an opt-in public page.

export const JOURNEY_NOTE_MAX = 280
export const JOURNEY_PHOTO_MAX_BYTES = 6 * 1024 * 1024
// Prompts older than this stop surfacing on Today (the goal screen still offers them).
export const JOURNEY_PROMPT_DAYS = 14
export const FEATURED_STRIP_MIN = 3

export const JOURNEY_KINDS = ['before', 'milestone', 'after'] as const
export type JourneyKind = (typeof JOURNEY_KINDS)[number]
export const journeyKindValidator = v.union(
  v.literal('before'),
  v.literal('milestone'),
  v.literal('after'),
)

export const photoStatusValidator = v.union(
  v.literal('pending'),
  v.literal('ok'),
  v.literal('rejected'),
)

export const featureStatusValidator = v.union(
  v.literal('pending'),
  v.literal('approved'),
  v.literal('rejected'),
)

export const journeyUrl = (id: string) => `https://gt.today/s/${id}`
